import { Modal, Spinner } from "@design";
import { useQuery } from "@tanstack/react-query";
import { useTranslation } from "react-i18next";
import { previewCompanyContextOptions } from "@/api";
import { Text } from "@/components/Text";
import { formatNumber } from "@/i18n/format";

/** The generated system-prompt context, fetched fresh each time it opens. */
export function ContextPreviewModal({ open, onClose }: Readonly<{ open: boolean; onClose: () => void }>) {
  const { t } = useTranslation("adminCompany");
  const preview = useQuery({ ...previewCompanyContextOptions(), enabled: open, staleTime: 0 });
  const data = preview.data?.data;
  return (
    <Modal open={open} onClose={onClose} title={t("preview.title")}>
      <div className="flex flex-col gap-3">
        <Text variant="body-sm" tone="secondary">
          {t("preview.description")}
        </Text>
        {preview.isPending && <Spinner />}
        {preview.isError && (
          <Text tone="error" role="alert">
            {t("preview.failed")}
          </Text>
        )}
        {data && (
          <>
            <Text variant="caption" tone="tertiary">
              {t("preview.tokens", { count: data.token_estimate, formatted: formatNumber(data.token_estimate) })}
            </Text>
            <pre className="max-h-[50dvh] overflow-auto whitespace-pre-wrap rounded-lg border border-border-subtle bg-surface-secondary p-4">
              <Text as="span" variant="code">
                {data.context_text}
              </Text>
            </pre>
          </>
        )}
      </div>
    </Modal>
  );
}
